import { useId, type InputHTMLAttributes, type ReactNode } from "react";
import { cn } from "../cn";

export type PropsRkInput = Omit<InputHTMLAttributes<HTMLInputElement>, "size"> & {
  readonly rotulo?: string;
  readonly auxiliar?: string;
  readonly erro?: string;
  readonly children?: ReactNode;
};

export function Input({
  rotulo,
  auxiliar,
  erro,
  className,
  id: idProp,
  ...resto
}: PropsRkInput) {
  const autoId = useId();
  const id = idProp ?? autoId;
  const erroId = `${id}-erro`;
  const auxId = `${id}-aux`;

  return (
    <div className="rk-field">
      {rotulo ? (
        <label htmlFor={id} className="rk-label rk-field__label">
          {rotulo}
        </label>
      ) : null}
      <input
        {...resto}
        id={id}
        aria-invalid={erro ? true : undefined}
        aria-describedby={
          [erro ? erroId : null, auxiliar ? auxId : null].filter(Boolean).join(" ") ||
          undefined
        }
        className={cn("rk-input", erro && "rk-input--error", className)}
      />
      {erro ? (
        <p id={erroId} role="alert" className="rk-caption rk-field__error">
          {erro}
        </p>
      ) : null}
      {!erro && auxiliar ? (
        <p id={auxId} className="rk-caption rk-field__helper">
          {auxiliar}
        </p>
      ) : null}
    </div>
  );
}
